<template>
  <div class="table no-treeview table-bg search">
    <div class="table-header center">
      <div class="table-tlt center-left">
        <h2>결제 리스트</h2>
      </div>
      <div v-if="loading === false" class="strong-text center">
        <span class="title">거래:&nbsp;&nbsp;</span><span :class="pagination.total > 0 ? 'plus' : (pagination.total < 0 ? 'minus': 'zero')">{{ Number(pagination.total).toLocaleString() }}</span>건
        <span class="title">&nbsp;&nbsp;/&nbsp;&nbsp;승인:&nbsp;&nbsp;</span><span :class="sum.approveCount > 0 ? 'plus' : (sum.approveCount < 0 ? 'minus': 'zero')">{{ Number(sum.approveCount).toLocaleString() }}</span>건
        <span class="title">&nbsp;&nbsp;/&nbsp;&nbsp;승인 금액:&nbsp;&nbsp;</span><span :class="sum.approveTotal > 0 ? 'plus' : (sum.approveTotal < 0 ? 'minus': 'zero')">{{ sum.approveTotal ? Number(sum.approveTotal).toLocaleString() : 0 }}</span>원
        <span class="title">&nbsp;&nbsp;/&nbsp;&nbsp;품목:&nbsp;&nbsp;</span><span :class="sum.paymentCount > 0 ? 'plus' : (sum.paymentCount < 0 ? 'minus': 'zero')">{{ Number(sum.paymentCount).toLocaleString() }}</span>개
        <span class="title">&nbsp;&nbsp;/&nbsp;&nbsp;품목 금액:&nbsp;&nbsp;</span><span :class="sum.paymentTotal > 0 ? 'plus' : (sum.paymentTotal < 0 ? 'minus': 'zero')">{{ sum.paymentTotal ? Number(sum.paymentTotal).toLocaleString() : 0 }}</span>원
      </div>
      <div class="table-btn center-right">
        <div class="btn-renew" @click="refreshList">
          <button class="btn btn-40"><span><img src="/static/img/ico-renew@2x.png" alt=""></span></button>
        </div>
        <div class="btn-export-excel" @click="downloadExcel">
          <button class="btn btn-40" :disabled="downloading">
            <span v-if="!downloading"><img src="/static/img/ico_excel@2x.png" alt=""></span>
            <ButtonLoading v-else></ButtonLoading>
          </button>
        </div>
      </div>
    </div>
    <div class="table-desc search">
      <table>
        <tr class="header">
          <th>거래 날짜</th>
          <th>승인 날짜</th>
          <th>상태</th>
          <th>승인 결과</th>
          <th>승인/거절 금액</th>
          <!-- <th>거절 사유</th> -->
          <th>거래 형태</th>
          <th>결제 수단</th>
          <th>설치 주소</th>
          <th>설치 장소</th>
          <th>결제 상품</th>
          <th>사업자명</th>
          <th>운영자명</th>
          <th>승인메시지</th>
        </tr>

        <tbody v-if="loading === false && pagination.total > 0">
          <tr v-for="item in payList" :key="item.ID">
            <td>
              <div>{{ item.paymentDate }}</div>
              <div class="time">{{ item.paymentTime }}</div>
            </td>
            <td>
              <div>{{ item.approveDate }}</div>
              <div class="time">{{ item.approveTime }}</div>
            </td>
            <td>
              <div>{{ item.state }}</div>
            </td>
            <td>
              <div>{{ item.approveResult }}</div>
            </td>
            <td>
              <div>{{ item.approvePrice }}</div>
            </td>
            <!--
            <td>
              <div>{{ item.resultCode }}</div>
            </td>
            -->
            <td>
              <div>{{ item.approveType }}</div>
            </td>
            <td>
              <div>{{ item.paymentMode }}</div>
            </td>
            <td>
              <div>{{ item.address }}</div>
            </td>
            <td>
              <div>{{ item.place }}</div>
            </td>
            <td>
              <div>{{ item.paymentDetail }}</div>
            </td>
            <td>
              <div>{{ item.companyName }}</div>
            </td>
            <td>
              <div>{{ item.operatorUID }}</div>
            </td>
            <td>
              <div>{{ item.resultMsg }}</div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="12">{{ loading ? '조회 중입니다.' : '조회 내역이 없습니다.' }}</td>
          </tr>
        </tbody>
      </table>

      <div class="pagination" v-if="pagination.total > 0">
        <span class="pagination-prev" @click="goPrev">
          <img src="/static/img/ico-arrow-line.png" alt />
        </span>

        <span v-if="pagination.pageArray[0] > 1" @click="goPage(1)">1</span>
        <span v-if="pagination.pageArray[0] > 1" @click="jumpPrev">...</span>
        <span
          v-for="n in pagination.pageArray"
          :key="n"
          :class="n === pagination.page ? 'page-num current' : 'page-num'"
          @click="goPage(n)"
          >{{ n }}
        </span>
        <span
          v-if="
            pagination.pageArray[pagination.pageArray.length - 1] <
            pagination.length
          "
          @click="jumpNext"
          >...
        </span>
        <span
          v-if="
            pagination.pageArray[pagination.pageArray.length - 1] <
            pagination.length
          "
          @click="goPage(pagination.length)"
          >{{ pagination.length }}
        </span>

        <span class="pagination-next" @click="goNext">
          <img src="/static/img/ico-arrow-line.png" alt />
        </span>

        <input
          type="number"
          v-model="pagination.input"
          @keyup.enter="goPage(Number(pagination.input))"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */

import Configuration from '@/js/Configuration';
import ButtonLoading from '@/components/include/ButtonLoading';

export default {
  props: [
    'searchCondition',
    'searchEvent',
    'startTime',
    'endTime',
    'downloading',
  ],
  components: {
    ButtonLoading,
  },
  data: () => ({
    payList: [],
    sum: null,
    pagination: {
      page: 1,
      total: 0,
      length: 1,
      perPage: 10,
      perLength: 5,
      pageArray: [],
      input: 1,
    },
    loading: true,
    scope: null,
    companyID: null,
  }),
  created() {
    const token = this.$jwtDecode(this.$cookie.get('accessToken'));
    this.scope = token.scope;
    this.companyID = token.companyID;
  },
  watch: {
    searchEvent() {
      this.pagination.page = 1;
      this.pagination.input = 1;
      this.pagination.total = 0;
      this.pagination.length = 1;

      this.getSum();
      this.getPayList();
    },
  },
  methods: {
    refreshList() {
      this.getSum();
      this.getPayList();
    },
    async getSum() {
      this.sum = null;

      try {
        let url = `${Configuration.value(
          'CPAYMENT_ADDRESS',
        )}/api/v1/cpayment/payment/sum?test=dump`;
        if (this.searchCondition) {
          url += `&${this.searchCondition}`;
        }
        if (this.scope > 2) {
          url += `&companyID=${this.companyID}`;
        }
        const res = await this.$http.get(url, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (res.status !== 200) {
          throw new Error(`Response status is "${res.status}"`);
        }
        if (res.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${res.data.resultCode}"`);
        }

        this.sum = {
          paymentTotal: res.data.paymentSum.paymentTotal,
          paymentCount: res.data.paymentSum.paymentCount,
          approveTotal: res.data.paymentSum.approveTotal,
          approveCount: res.data.paymentSum.approveCount,
        };
      } catch (e) {
        this.sum = null;
        alert('정보를 가져오는데 실패하였습니다.\n잠시후 다시 시도해주세요.');

        console.error(e);
      }
    },
    async getPayList() {
      this.payList = [];
      this.pagination.input = this.pagination.page;
      this.loading = true;

      try {
        let countURL = `${Configuration.value(
          'CPAYMENT_ADDRESS',
        )}/api/v1/cpayment/payment/count?test=dump`;
        if (this.searchCondition) {
          countURL += `&${this.searchCondition}`;
        }
        if (this.scope > 2) {
          countURL += `&companyID=${this.companyID}`;
        }
        const count = await this.$http.get(countURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (count.status !== 200) {
          throw new Error(`Response status is "${count.status}"`);
        }
        if (count.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${count.data.resultCode}"`);
        }
        if (count.data.count < 1) {
          this.pagination.page = 1;
          this.pagination.total = 0;
          this.pagination.length = 1;
          this.loading = false;
          return;
        }

        this.pagination.total = count.data.count;
        this.pagination.length = Math.ceil(
          this.pagination.total / this.pagination.perPage,
        );

        const pageBack = Math.floor((this.pagination.perLength - 1) / 2);
        const pageForward = this.pagination.perLength - 1 - pageBack;
        let firstPage = this.pagination.page - pageForward;
        let lastPage = this.pagination.page + pageBack;
        if (firstPage < 1) {
          firstPage = 1;
          lastPage = this.pagination.perLength;
        }
        if (lastPage > this.pagination.length) {
          lastPage = this.pagination.length;
        }
        if (lastPage - firstPage + 1 < this.pagination.perLength) {
          if (firstPage > 1) {
            firstPage -= this.pagination.perLength - lastPage + firstPage - 1;
            if (firstPage < 1) {
              firstPage = 1;
            }
          } else if (lastPage < this.pagination.length) {
            lastPage += this.pagination.perLength - lastPage + firstPage - 1;
            if (lastPage > this.pagination.length) {
              lastPage = this.pagination.length;
            }
          }
        }

        this.pagination.pageArray = [];
        for (let i = firstPage; i <= lastPage; i++) {
          this.pagination.pageArray.push(i);
        }

        let num =
          this.pagination.total -
          (this.pagination.page - 1) * this.pagination.perPage;
        const payList = [];

        let listURL = `${Configuration.value(
          'CPAYMENT_ADDRESS',
        )}/api/v1/cpayment/payment/list?page=${this.pagination.page}&limit=${
          this.pagination.perPage
        }&showAll=true`;
        if (this.searchCondition) {
          listURL += `&${this.searchCondition}`;
        }
        if (this.scope > 2) {
          listURL += `&companyID=${this.companyID}`;
        }
        const list = await this.$http.get(listURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (list.status !== 200) {
          if (list.status === 204) {
            this.pagination.page = 1;
            this.pagination.total = 0;
            this.pagination.length = 1;
            this.loading = false;
            return;
          }

          throw new Error(`response status is "${list.status}"`);
        }
        if (list.data.resultCode !== '0000') {
          throw new Error(`resultcode is "${list.data.resultCode}"`);
        }

        for (let i = 0; i < list.data.payments.length; i++) {
          const p = list.data.payments[i];
          const approveResult = this.$getConstName(
            'approveResult',
            p.approveResult,
          );
          const approveType = this.$getConstName('approveType', p.approveType);
          const paymentMode = this.$getConstName('paymentMode', p.paymentMode);
          const aDate = p.approveAt ? this.$moment(p.approveAt).format('YYYY.MM.DD') : '-';
          // const aTime = p.approveAt ? this.$moment(p.approveAt).format('hh:mm A') : '-';
          const aTime = p.approveAt ? this.$moment(p.approveAt).format('HH:mm:ss') : '-';
          let paymentDetail = null;
          if (p.paymentDetails) {
            let productCount = 0;
            for (let j = 0; j < p.paymentDetails.length; j++) {
              const pd = p.paymentDetails[j];
              productCount += pd.productCount;
            }
            if (productCount === 1) {
              // paymentDetail = `${p.paymentDetails[0].productName.substr(0, 4)}`;
              paymentDetail = `${p.paymentDetails[0].productName}`;
            } else if (productCount > 1) {
              // paymentDetail = `${p.paymentDetails[0].productName.substr(0, 2)} 외 ${productCount - 1} 개`;
              paymentDetail = `${p.paymentDetails[0].productName} 외 ${productCount - 1} 개`;
            }
          }
          const state = this.$getConstName('state', p.state);

          const payment = {
            num,
            ID: p.paymentID,
            paymentDate: this.$moment(p.paymentAt).format('YYYY.MM.DD'),
            // paymentTime: this.$moment(p.paymentAt).format('hh:mm A'),
            paymentTime: this.$moment(p.paymentAt).format('HH:mm:ss'),
            approveDate: aDate,
            approveTime: aTime,
            paymentDetail: paymentDetail || '-',
            state: state || '-',
            approveResult: approveResult || '-',
            approvePrice: p.approveResult
              ? `${p.approvePrice.toLocaleString()}원`
              : '-',
            approveType: approveType || '-',
            paymentMode: paymentMode || '-',
            address: p.address ? p.address : '-',
            place: p.place ? p.place : '-',
            divisionID: p.divisionID ? p.divisionID : '-',
            deviceID: p.deviceID ? p.deviceID : '-',
            companyName: p.companyName ? p.companyName : '-',
            operatorUID: p.OperatorUID ? p.OperatorUID : '-',
            resultCode: p.resultCode ? p.resultCode : '-',
            resultMsg: p.resultMsg ? `${p.resultMsg}(${p.resultCode})` : '-',
          };
          payList.push(payment);

          num--;
        }

        this.payList = payList;
        this.loading = false;
      } catch (e) {
        this.pagination.page = 1;
        this.pagination.total = 0;
        this.pagination.length = 1;
        this.payList = [];
        this.loading = false;

        alert('정보를 가져오지 못했습니다.\n잠시후 다시 시도해주세요.');
        console.error(e);
      }
    },
    goPrev() {
      if (this.pagination.page <= 1) {
        return;
      }
      this.pagination.page--;

      this.getPayList();
    },
    goNext() {
      if (this.pagination.page >= this.pagination.length) {
        return;
      }
      this.pagination.page++;

      this.getPayList();
    },
    jumpPrev() {
      if (
        Array.isArray(this.pagination.pageArray) &&
        this.pagination.pageArray.length > 0
      ) {
        this.pagination.page = this.pagination.pageArray[0];
        this.pagination.page--;
      } else {
        this.pagination.page = 1;
      }

      if (this.pagination.page < 1) {
        this.pagination.page = 1;
      }

      this.getPayList();
    },
    jumpNext() {
      if (
        Array.isArray(this.pagination.pageArray) &&
        this.pagination.pageArray.length > 0
      ) {
        this.pagination.page = this.pagination.pageArray[
          this.pagination.pageArray.length - 1
        ];
        this.pagination.page++;
      } else {
        this.pagination.page = 1;
      }

      if (this.pagination.page > this.pagination.length) {
        this.pagination.page = this.pagination.length;
      }

      this.getPayList();
    },
    goPage(page) {
      if (page < 1) {
        page = 1;
      }
      if (page > this.pagination.length) {
        page = this.pagination.length;
      }
      this.pagination.page = page;
      this.getPayList();
    },
    downloadExcel() {
      this.$emit('download');
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/payHistory/PayList.vue